import Vue from "vue";
import App from "./App.vue";
import VueRs from "@appbaseio/reactivesearch-vue";
import VueRouter from "vue-router";

import Movies from "./Movies.vue";
import MoviesImages from "./MoviesImages.vue";
import Home from "./Home.vue";

Vue.use(VueRs);
Vue.config.productionTip = false;

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    { path: "/", component: Home },
    { path: "/images", component: MoviesImages },
    { path: "/movies", component: Movies }
  ]
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  render: h => h(App)
});
